// `?t=<seconds>` on /g/:id (F2: a transcript search hit links here). Kept as its own pure
// function so it's testable without mounting the player or mocking hls.js.

/** Parses the `t` query parameter into a seek time in seconds, or undefined when absent,
 * not a number, negative, or not finite (NaN/Infinity never seek the player). */
export function parseSeekSeconds(raw: string | null): number | undefined {
  if (raw === null || raw === "") return undefined;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return undefined;
  return n;
}
